import React from "react";
import Button from "../../UIComponents/Button/Button";
import "./Booking.scss";
const Booking = () => {
  return (
    <section className="booking">
      <div className="row">
        <div className="book">
          <div className="book-form">
            <form action="#" className="form">
              <div className="u-center-text u-margin-bottom-medium">
                <h2 className="heading-secondary">start booking now</h2>
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-input"
                  placeholder="Full Name"
                  id="name"
                  required
                />
                <label htmlFor="name" className="form-label">
                  Full name
                </label>
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-input"
                  placeholder="Email address"
                  id="email"
                  typeof="email"
                  required
                />
                <label htmlFor="email" className="form-label">
                  Email address
                </label>

                <div className="form-group">
                  <div className="form-radio-group">
                    <input
                      type="radio"
                      className="form-radio-group-input"
                      id="small"
                      name="size"
                    />
                    <label className="form-radio-group-label" htmlFor="small">
                      <span className="form-radio-botton"></span>
                      small group
                    </label>
                  </div>
                  <div className="form-radio-group">
                    <input
                      type="radio"
                      className="form-radio-group-input"
                      id="large"
                      name="size"
                    />
                    <label className="form-radio-group-label" htmlFor="large">
                      <span className="form-radio-botton"></span>
                      large group
                    </label>
                  </div>
                </div>
              </div>
              <Button
                href="#popup"
                btnColor="btn-color-red-flag"
                text="continue"
              />
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Booking;
